import { SchemaApiValue, User } from "./Models";

export type CreateAccessesToModels = {
    accessEmail: string;
    schemaId: string,
    accessTypeId: AIAccessTypeEnum
}

export type AccessesToModelsDto = {
    id: string;
    user: User;
    schemaId: string;
    accessTypeId: AIAccessTypeEnum;
    createdDate: Date;
    updatedDate: Date;
    schema: SchemaApiValue;
}


export enum AIAccessTypeEnum {
    Admin = "Admin",
    Observer = "Observer"
}